import styled from 'styled-components';

export const ContactLabel = styled.h2`
    margin-bottom: 20px;
`;

export const FormContainer = styled.div`
    margin: 10% 15%;
`;

export const Form = styled.form`
`;

export const InputContainer = styled.div`
    margin-bottom: 20px;
    width: 100%;
`;

export const Label = styled.label``;

export const InputField = styled.input`
    display: block;
    padding: 10px 12px;
    width: 100%;
    margin-top: 10px;
    border-radius: 5px;
    border: 1px solid black;
`;